module.exports = __webpack_public_path__ + "media/images/about-us-bg-ddab1d13ec8472d6c544596fd6fb3df6.png";